import React from 'react'
import { Colors } from 'src/constants/colors'
import SalesloftIcon from 'src/assets/img/salesloft.svg'
import { Anchor, FjText } from 'src/components/Common'
import { ExternalLink } from 'react-feather'

type SalesloftClassroomThumbnailProps = {
  url: string
  title: string
}

export const SalesloftClassroomThumbnail = ({ url, title }: SalesloftClassroomThumbnailProps) => {
  return (
    <Anchor
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '550px',
        borderRadius: '16px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      type="mintGreen"
    >
      <img src={SalesloftIcon} alt={title} />
      <span style={{ marginTop: '32px', display: 'flex', alignItems: 'center' }}>
        <FjText fontSize="16px" color={Colors.cyanGreen}>
          Click to open call in Salesloft
        </FjText>
        <ExternalLink
          size={17}
          color={Colors.cyanGreen}
          strokeWidth={2}
          style={{ marginBottom: '2px', marginLeft: '8px' }}
        />
      </span>
    </Anchor>
  )
}
